import { Col, message, Row, Select, Space, Tag } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    ModalItem,
    FormItem,
    InputItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    DatePickerItem,
    TextAreaItem,
    TableItem,
    ErrorItem,
    SelectInsumosItem,
    SwitchItem,
} from "../../../../Components/Items";
import moment from "moment";
import axios from "axios";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";

const { Option } = Select;

class EditarAgrupacion extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        archivos: [],
        imagenes: [],
        previewImage: '',
        previewVisible: false,
        previewTitle: '',
        previewImageArchivo: '',
        previewVisibleArchivo: false,
        previewTitleArchivo: '',
        todasInsumosVenta: [],
        objetoInsumosVenta: null,
        modalVerEtiqueta: false,
        piezasSeleccionadas: [],
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.consultarInformacionLote();
        }

    }

    consultarInformacionLote() {
        this.setState({ loading: true });
        axios.post("agrupaciones/datosParaVerAgrupacion", {
            agrupacionId: this.props.agrupacionId,
            empresaId: this.props.empresaId,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            if (res.data.success === 2) {
                this.setState({
                    loading: false,
                    todasInsumosVenta: res.data.insumosVenta,
                    objetoInsumosVenta: res.data.insumosVenta.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.stringBuscar}
                            </Option>
                        );
                    }),
                    piezasLote: res?.data?.lote?.piezas || [],
                    piezasSeleccionadas: res?.data?.agrupacion?.piezas && Array.isArray(res.data.agrupacion.piezas) ?
                        res.data.agrupacion.piezas.map(pieza => pieza.subLoteId)
                        : [],
                });
                this.formRef.current.setFieldsValue({
                    ...res.data.agrupacion,
                    fechaEntrega: res.data.agrupacion.fechaEntrega ? moment(res.data.agrupacion.fechaEntrega) : null,
                })
            } else {
                message.error("Error al consultar la información del lote");
            }
        })
    }

    cerrarEditarAgrupacion(valores) {
        this.formRef.current.resetFields();
        this.props.cerrarEditarAgrupacion(valores);
    }

    onSelectChange = (piezasSeleccionadas) => {
        let nuevasPiezasSeleccionadas = [];
        for (const valuePiezaId of piezasSeleccionadas) {
            const pieza = this.state.piezasLote.find(p => p._id.toString() === valuePiezaId.toString());
            if (!pieza.agrupacionLoteId || pieza.estado === 0 || pieza.agrupacionLoteId.toString() === this.props.agrupacionId.toString()) {
                nuevasPiezasSeleccionadas.push(valuePiezaId);
            }
        }

        this.setState({ piezasSeleccionadas: nuevasPiezasSeleccionadas });
        if (nuevasPiezasSeleccionadas.length === 1) {
            message.success(`Se ha seleccionado ${nuevasPiezasSeleccionadas.length} pieza`)
        } else if (nuevasPiezasSeleccionadas.length > 1) {
            message.success(`Se han seleccionado ${nuevasPiezasSeleccionadas.length} piezas`)
        }
    }

    cerrarEditarLote(e) {

        this.props.cerrarEditarLote(e);
        this.setState({
            archivos: [],
            imagenes: [],
        });
        this.formRef.current.resetFields();
    }

    onFinish(values) {
        if ((!this.state.piezasSeleccionadas || this.state.piezasSeleccionadas.length === 0) && !this.props.cancelarEdiciones) {
            message.error("Debe seleccionar al menos una pieza para agregar la agrupación");
            return;
        }
        this.setState({ loading: true });
        axios.post("agrupaciones/editarAgrupacion", {
            agrupacionId: this.props.agrupacionId,
            empresaId: this.props.empresaId,
            cancelarEdiciones: this.props.cancelarEdiciones,
            piezasSeleccionadas: this.state.piezasSeleccionadas,
            ...values,
        }, {
            headers: this.props.headersToken,
        }).then((res) => {
            this.setState({ loading: false });
            if (res.data.success === 2) {
                message.success("Agrupacion editado correctamente");
                this.cerrarEditarAgrupacion({ cerrarModificado: true });
            } else {
                message.error("Error al editar la agrupación");
            }
        })
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const ediciones = this.props.ediciones || {};
        console.log(ediciones)
        return (
            <>
                <ModalItem
                    title={"Editar Agrupación"}
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={() => this.cerrarEditarAgrupacion()}
                    paddingTop
                    width={1000}
                >
                    <Form
                        ref={this.formRef}
                        name="EditarAgrupacion"
                        layout
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed.bind(this)}
                        bottom={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space style={{ maxWidth: '100%', display: "flex", justifyContent: "right" }} wrap>
                                    <ButtonItem
                                        type="primary"
                                        onClick={() => this.cerrarEditarAgrupacion()}
                                        rojo
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Cerrar
                                    </ButtonItem>
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Editar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                    >
                        <Row >
                            <Col span={12}>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Empleados"
                                            name={"empleados"}
                                            fieldKey={"empleados"}
                                            margin
                                            required={ediciones.editarEmpleadosRequerido}
                                        >
                                            <SelectEmpleadosItem
                                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                headersToken={this.props.headersToken}
                                                sinBorde
                                                autoFocus
                                                disabled={!ediciones.editarEmpleados && this.props.cancelarEdiciones}
                                                dropdownMatchSelectWidth={600}
                                                width="100%"
                                                mode="multiple"
                                                placeholder="Empleados"
                                            />
                                        </FormItem>
                                    </>
                                )}
                                <FormItem
                                    label="Venta"
                                    name="formaVentaId"
                                    fieldKey="formaVentaId"
                                    margin
                                    required={ediciones.editarInsumosVentaRequerido}
                                >
                                    <SelectItem
                                        placeholder="Seleccionar Venta"
                                        disabled={!ediciones.editarInsumosVenta && this.props.cancelarEdiciones}
                                    >
                                        {this.state.objetoInsumosVenta}
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    label="Fecha Entrega"
                                    name={"fechaEntrega"}
                                    fieldKey={"fechaEntrega"}
                                    margin
                                    required={ediciones.editarFechaEntregaRequerido}
                                >
                                    <DatePickerItem
                                        placeholder="Fecha Entrega"
                                        style={{ width: '100%' }}
                                        format="DD/MM/YYYY"
                                        disabled={!ediciones.editarFechaEntrega && this.props.cancelarEdiciones}
                                        disabledDate={(current) => current && current < moment().startOf('day')}
                                    />
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                {this.props.taxidermia && (
                                    <>
                                        <FormItem
                                            label="Posición"
                                            name={"posicion"}
                                            fieldKey={"posicion"}
                                            margin
                                            required={ediciones.editarPosicionRequerido}
                                        >
                                            <InputItem placeholder="Ej. Derecha" disabled={!ediciones.editarPosicion && this.props.cancelarEdiciones} />
                                        </FormItem>
                                        <FormItem
                                            label="Talla"
                                            name={"tallaPiel"}
                                            fieldKey={"tallaPiel"}
                                            margin
                                            required={ediciones.editarTallaPielRequerido}
                                        >
                                            <InputItem placeholder="Talla" disabled={!ediciones.editarTalla && this.props.cancelarEdiciones} />
                                        </FormItem>
                                        <FormItem
                                            label="Forma"
                                            name={"formaId"}
                                            fieldKey={"formaId"}
                                            margin
                                        >
                                            <SelectInsumosItem
                                                disabled={!ediciones.editarTalla && this.props.cancelarEdiciones}
                                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                                headersToken={this.props.headersToken}
                                                autoFocus
                                                dropdownMatchSelectWidth={600}
                                                placeholder="Forma"
                                                tiposInsumos="activos"
                                            />
                                        </FormItem>
                                        <FormItem
                                            label="H. extra"
                                            name="horarioExtra"
                                            fieldKey={"horarioExtra"}
                                            margin
                                        >
                                            <SwitchItem disabled={!ediciones.editarTalla && this.props.cancelarEdiciones} />
                                        </FormItem>
                                    </>
                                )}
                            </Col>
                        </Row>
                        <HeaderItem>OBSERVACIONES</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <FormItem
                                        label="Observaciones"
                                        name={"observaciones"}
                                        fieldKey={"observaciones"}
                                        margin
                                        labelCol={{ span: 4 }}
                                        wrapperCol={{ span: 20 }}
                                        required={ediciones.editarObservacionesRequerido}
                                    >
                                        <TextAreaItem
                                            disabled={!ediciones.editarObservaciones && this.props.cancelarEdiciones}
                                            placeholder="Observaciones"
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                        <HeaderItem>PIEZAS</HeaderItem>
                        <BoxItem>
                            <Row>
                                <Col span={24}>
                                    <TableItem
                                        loading={this.state.loading}
                                        size="small"
                                        dataSource={this.state.piezasLote}
                                        rowSelection={(!this.props.cancelarEdiciones || this.props.habilitarPiezas) && {
                                            selectedRowKeys: this.state.piezasSeleccionadas,
                                            onChange: this.onSelectChange.bind(this),
                                            getCheckboxProps: (record) => ({
                                                disabled: (!!record.agrupacionLoteId || record.estado === 0) && record.agrupacionLoteId?.toString() !== this.props.agrupacionId?.toString(), // desactiva si tiene agrupación
                                                title: (record.agrupacionLoteId || record.estado === 0) ? "Ya está agrupado" : "",
                                            }),
                                        }}
                                        columns={[
                                            {
                                                title: "Descripción",
                                                dataIndex: "descripcion",
                                                key: "descripcion",
                                                width: "40%",
                                                render: (text, record) => (
                                                    <span>
                                                        {record.descripcion}
                                                    </span>
                                                ),
                                            },
                                            {
                                                title: "Cantidad",
                                                dataIndex: "cantidad",
                                                key: "cantidad",
                                                width: "20%",
                                            },
                                            {
                                                title: "Estado",
                                                dataIndex: "agrupacionLoteId",
                                                key: "agrupacionLoteId",
                                                render: (agrupacionLoteId, record) => {
                                                    if (agrupacionLoteId || record.estado === 0) {
                                                        if (agrupacionLoteId?.toString() === this.props.agrupacionId?.toString()) {
                                                            return <Tag color="blue">Agrupación Actual</Tag>;
                                                        }
                                                        if (record.estado === 0) {
                                                            return <Tag color="red">Cancelada</Tag>;
                                                        }
                                                        return <Tag color="red">Agrupado</Tag>;
                                                    } else {
                                                        return <Tag color="green">Disponible</Tag>;
                                                    }
                                                },
                                                width: "30%",
                                            },
                                        ]}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        </BoxItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(EditarAgrupacion);
